"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyStagesDetailRequest = void 0;
var MyStagesDetailRequest = /** @class */ (function () {
    function MyStagesDetailRequest() {
    }
    return MyStagesDetailRequest;
}());
exports.MyStagesDetailRequest = MyStagesDetailRequest;
;
//# sourceMappingURL=myStagesDetail.request.js.map